import { render, staticRenderFns } from "./EarlyYearList.vue?vue&type=template&id=15cfd942"
import script from "@/controllers/custom/early-year/early-year-list.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/early-year/early-year-list.js?vue&type=script&lang=js&external"
import style0 from "./EarlyYearList.vue?vue&type=style&index=0&id=15cfd942&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports